import React from "react";
import { Navigate } from "react-router-dom";

// All pages that rely on 3rd party components (other than Bootstrap) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Layouts
import AuthLayout from "./layouts/Auth";
import DashboardLayout from "./layouts/Dashboard";

// Guards
import AuthGuard from "./components/guards/AuthGuard";

// Auth
import Page404 from "./pages/auth/Page404";

//Taps
import Taps from "./pages/taps/Taps";

// SQL Editor with v1/v2 toggle
import EditorToggle from "./pages/sql/EditorToggle";

//Jobs
import Overview from "./pages/jobs/Overview";
import Push from "./pages/jobs/Push";
import Observability from "./pages/observability";

// Code Environment
import Code from "./pages/Code";

// Admin
import TapAdmin from "./pages/admin/TapAdmin";

// Protected routes
import ProtectedPage from "./pages/protected/ProtectedPage";

const routes = [
  {
    path: "taps",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "mytaps",
        element: <Taps />,
      },
    ],
  },
  {
    path: "sql",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "editor",
        element: <EditorToggle />,
      },
    ],
  },
  {
    path: "jobs",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "overview",
        element: <Overview />,
      },
      {
        path: "push",
        element: <Push />,
      },
    ],
  },
  {
    path: "observability",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Observability />,
      },
    ],
  },
  {
    path: "code",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Code />,
      },
    ],
  },
  {
    path: "admin",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "taps",
        element: <TapAdmin />,
      },
    ],
  },
  {
    path: "",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <ProtectedPage />,
      },
    ],
  },
  {
    path: "*",
    element: <AuthLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];

export default routes;
